module.exports = __webpack_public_path__ + "static/media/unblock-icn.09363424.svg";